import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { DriveSettingsCatalogKey } from './drive.i18n.js';
import { DRIVE_SETTINGS_CATALOG } from './drive.i18n.js';

export type DriveSettingsMessageId = `driveSettings:${DriveSettingsCatalogKey}`;

const PREFIX_LENGTH = 'driveSettings:'.length;

/** `t()` for the stop-gap `driveSettings:` scope (see `drive.i18n.ts`). */
export function useDriveT(): { t: (id: DriveSettingsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: DriveSettingsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as DriveSettingsCatalogKey;
      const raw = DRIVE_SETTINGS_CATALOG[locale][key] ?? DRIVE_SETTINGS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
